// Legal entity / branch / warehouse scope of a user (plan 4.3, FR-ORG-05).
// No imports: shared by tenancy.js (list filters) and organization.js.

/** Normalized scope; null when the user is not restricted. */
export function normalizeScope(raw) {
  if (!raw || raw.allLegalEntities === true) return null;
  const list = (v) => (Array.isArray(v) ? [...new Set(v.filter((x) => typeof x === "string" && x))] : []);
  return { legalEntityIds: list(raw.legalEntityIds), branchIds: list(raw.branchIds), warehouseIds: list(raw.warehouseIds) };
}

const WAREHOUSE_FIELDS = ["warehouseId", "sourceWarehouseId", "destWarehouseId"];

/**
 * Whether a record is visible under `scope` (null = everything). Records
 * without a legal entity are pre-migration data and stay visible; an empty
 * branch / warehouse list means every branch / warehouse of the allowed
 * legal entities.
 */
export function recordInScope(scope, row, collectionName = null) {
  if (!scope || !row) return true;
  if (collectionName === "legalEntities") return scope.legalEntityIds.includes(row.id);
  if (row.legalEntityId && !scope.legalEntityIds.includes(row.legalEntityId)) return false;
  if (collectionName === "branches" && scope.branchIds.length) return scope.branchIds.includes(row.id);
  if (row.branchId && scope.branchIds.length && !scope.branchIds.includes(row.branchId)) return false;
  if (scope.warehouseIds.length) {
    if (collectionName === "warehouses") return scope.warehouseIds.includes(row.id);
    const whs = WAREHOUSE_FIELDS.map((f) => row[f]).filter(Boolean);
    if (whs.length && !whs.some((w) => scope.warehouseIds.includes(w))) return false;
  }
  return true;
}

export function filterByScope(scope, rows = [], collectionName = null) {
  return scope ? rows.filter((r) => recordInScope(scope, r, collectionName)) : rows;
}

